import { CustomerProjectGateway } from './customer-project-gateway.interface';

export const initCustomerProjectAPI = (
  apiSlice: any,
  gateway: CustomerProjectGateway
) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['CustomerProjects', 'Notification'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getAllCustomerProjects: builder.query({
          query: gateway.getAllProjects,
        }),
        getCustomerProjectByToken: builder.query({
          query: gateway.getProjectByToken,
        }),
        getCustomerTasksByProject: builder.query({
          query: gateway.getTasksByProject,
        }),
        postCustomerAskSomething: builder.mutation({
          query: gateway.postCustomerAskSomething,
        }),
        getCustomerNotificationsByProject: builder.query({
          query: gateway.getCustomerNotificationsByProject,
          providesTags: ['Notification'],
        }),
        patchCustomerNotificationAsSeen: builder.mutation({
          query: gateway.patchCustomerNotificationAsSeen,
          invalidatesTags: ['Notification'],
        }),
      }),
      overrideExisting: false,
    });
};

export interface CustomerProjectSliceType {
  useGetAllCustomerProjectsQuery: Function;
  useGetCustomerProjectByTokenQuery: Function;
  useGetCustomerTasksByProjectQuery: Function;
  usePostCustomerAskSomethingMutation: Function;
  useGetCustomerNotificationsByProjectQuery: Function;
  usePatchCustomerNotificationAsSeenMutation: Function;
}
